import Vue from 'vue';
import Vuex from 'vuex';
import ls from './local_storage.js';
Vue.use(Vuex);

ls.init();
export default new Vuex.Store({
  state: {
    livers: [],
    favoriteLivers: {},
    notifyMinutes: 10,
    canReload: false,
    reloadMinutes: 60,
    reloadProcess: null
  },
  mutations: {
    setLivers(state, livers) {
      state.livers = livers;
      return ls.put('livers', state.livers);
    },
    setFavorite(state, liver) {
      state.favoriteLivers[liver.id] = liver.isFavorite;
      return ls.put('favoriteLivers', state.favoriteLivers);
    },
    setFavoriteLivers(state, favoriteLivers) {
      state.favoriteLivers = favoriteLivers;
      return ls.put('favoriteLivers', favoriteLivers);
    },
    setNotifyMinutes(state, notifyMinutes) {
      state.notifyMinutes = notifyMinutes;
      return ls.put('notifyMinutes', notifyMinutes);
    },
    setCanReload(state, canReload) {
      state.canReload = canReload;
      return ls.put('canReload', canReload);
    },
    setReloadMinutes(state, reloadMinutes) {
      state.reloadMinutes = reloadMinutes;
      return ls.put('reloadMinutes', reloadMinutes);
    },
    setReloadProcess(state, reloadProcess) {
      state.reloadProcess = reloadProcess;
    }
  }
});